<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="中文名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=20
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="name_en"
                    label="英文名称"
                    prop="name_en"
                    :help="formErr.name_en"
                    :validateStatus='!formErr.name_en||formErr.name_en==""?"":"error"'
            >
                <a-input
                        :maxLength=20
                        v-model="form.name_en"
                        @change="(e) => { formErr.name_en=''}"
                        @blur="(e) => {  form.name_en = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="name_lang"
                    label="本语种名称"
                    prop="name_lang"
                    :help="formErr.name_lang"
                    :validateStatus='!formErr.name_lang||formErr.name_lang==""?"":"error"'
            >
                <a-input
                        :maxLength=20
                        v-model="form.name_lang"
                        @change="(e) => { formErr.name_lang=''}"
                        @blur="(e) => {  form.name_lang = e.target.value.trim() }"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="html_code"
                    label="html语种简写"
                    prop="html_code"
                    :help="formErr.html_code"
                    :validateStatus='!formErr.html_code||formErr.html_code==""?"":"error"'
            >
                <a-input
                        v-model="form.html_code"
                        @change="(e) => { formErr.html_code=''}"
                        @blur="(e) => {  form.html_code = e.target.value.trim() }"
                />
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }" >
                确定
            </a-button>
            <a-button  @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "languageListForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig,
                form: {
                    name_lang:"",
                    name_en:"",
                    name:"",
                    html_code:""
                },
                formErr: {
                    name_lang:"",
                    name_en:"",
                    name:"",
                    html_code:""
                },
                rules: {
                    name: [ {required: true, message: "请输入中文名称", trigger: "blur"},,{ whitespace: true, message: "请输入中文名称" },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  }, ],
                    name_en: [{required: true, message: "请输入英文名称", trigger: "blur"}, {  whitespace: true, message: "请输入英文名称" }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name_en)}  , trigger: "blur"  },],
                    name_lang: [{required: true, message: "请输入本语种名称", trigger: "blur"}, {  whitespace: true, message: "请输入本语种名称" }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name_lang)}  , trigger: "blur"  },],
                     },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.language.ALANGSET_EDIT({id: a}).then(res => {
                        let val = res.data.data
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.form={
                    name_lang:"",
                        name_en:"",
                        name:""
                }
                this.formErr={ name_lang:"", name_en:"", name:"" },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.language.ALANGSET_EDITPOST : url = API.language.ALANGSET_EDITPOST
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
